/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Lines_FavoritesInputs */

const fr_map_lines_favorites = /** @type {(inputs: Map_Lines_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes favorites`)
};

const en_map_lines_favorites = /** @type {(inputs: Map_Lines_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorite lines`)
};

/**
* | output |
* | --- |
* | "Favorite lines" |
*
* @param {Map_Lines_FavoritesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_lines_favorites = /** @type {((inputs?: Map_Lines_FavoritesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Lines_FavoritesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_lines_favorites(inputs)
	return en_map_lines_favorites(inputs)
});